import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

export interface NavLinkProps {
  to: string;
  label: string;
  isActive?: boolean;
  className?: string;
}

/**
 * NavLink component for header navigation.
 * Shows underline on active state, with dark mode support.
 */
export const NavLink: React.FC<NavLinkProps> = ({
  to,
  label,
  isActive = false,
  className = '',
}) => {
  const baseClasses = `
    px-3 py-2 text-sm font-medium transition-colors
    text-secondary-600 dark:text-secondary-300
    hover:text-primary-600 dark:hover:text-primary-400
  `
    .trim()
    .replace(/\s+/g, ' ');

  const activeClasses = `
    text-primary-600 dark:text-primary-400
    border-b-2 border-primary-600 dark:border-primary-400
    font-semibold
  `
    .trim()
    .replace(/\s+/g, ' ');

  return (
    <RouterLink
      to={to}
      className={`${baseClasses} ${isActive ? activeClasses : ''} ${className}`}
      aria-current={isActive ? 'page' : undefined}
    >
      {label}
    </RouterLink>
  );
};

export default NavLink;
